import { Action } from '@ngrx/store';
import { RefNo } from '../../model/ngrx/reference-number.model';
import * as RefNoActions from './../actions/reference-number.actions';

export type Actions = RefNoActions.Actions;

// const initialState: RefNo = {
//     quoteReferenceNumber: ''
// };

// const newState = (state, newData) => {
//     return Object.assign({}, state, newData);
// };

export function refReducer(state: RefNo[] = [], action: RefNoActions.Actions) {
    switch (action.type) {
        case RefNoActions.ADD_REFNO:
            return [...state, action.payload];
        // return newState(state, { quoteReferenceNumber: action.payload });

        // Add this case:
        case RefNoActions.REMOVE_REFNO:
            state = []; // [...state].splice(action.payload, 1);
            return state;
        // Add this case:
        case RefNoActions.EDIT_REFNO:
            if (state.length > 0) {
                //  state[0].quoteNumberFlag = action.payload;
                console.log('state', state);
                let localState = state[0];
                localState = {...localState, quoteNumberFlag: action.payload};
                console.log(localState);
                state = [...state.slice(1), localState];
                console.log(state);

            }
            return state;
        default:
            return state;
    }
}
